import React from 'react';
import MetricView from '../common/MetricView';
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';
import Tag from '@amzn/meridian/tag';
import Heading from '@amzn/meridian/heading';
import { displayTime, getFcCode } from '../../../utils';
import Link from '@amzn/meridian/link';
import OutboundPlanningThroughputExpanded from './OutboundPlanningThroughputExpanded';
import { THROUGHPUT_KEY_MAP, SSD_FEATURE_FLAGS_LIST, BUSINESS_VIEW_NAME } from '../../../../../utils/constants';
import { HALF, PERIOD } from '../../../../../utils/constants';
import { isFeatureFlagEnabled } from '../../../utils';

const ShiftPlannedThroughput = ({ singlesEnabled, shift, plannedThroughput, businessType, plan }) => {
  const isRushIndirectRulesEnabled = plan
    ? isFeatureFlagEnabled(plan.input.adminSettings, SSD_FEATURE_FLAGS_LIST.rushIndirectRulesEnabled)
    : false;

  const isNarrowWindowsEnabled = plan
    ? isFeatureFlagEnabled(plan.input.adminSettings, SSD_FEATURE_FLAGS_LIST.narrowWindowsEnabled)
    : false;

  const shiftPlannedThroughput = shift
    ? plannedThroughput.filter(({ start_time_local, end_time_local, description = '' }) => {
        return (
          start_time_local >= shift.start &&
          end_time_local <= shift.end &&
          description.includes(isNarrowWindowsEnabled ? PERIOD : HALF)
        );
      })
    : [];
  return (
    <MetricView
      headerComponent={
        <Row width="100%" alignmentHorizontal="justify">
          <Heading level={2} type="h300" alignment="left">
            <Text>Outbound Planning Throughput (units/hr)</Text>
          </Heading>
          <Row>
            <Text type="b300">
              <Tag type={singlesEnabled ? 'success' : 'error'}>{`Singles Processing: ${
                singlesEnabled ? 'On' : 'Off'
              }`}</Tag>
            </Text>
            <Link
              href={`https://throughput-iad.iad.proxy.amazon.com/${getFcCode()}/lagrange/`}
              target="_blank"
              rel="noopener noreferrer">
              Lagrange
            </Link>
            <OutboundPlanningThroughputExpanded
              plannedThroughput={plannedThroughput}
              businessType={businessType}
              isNarrowWindowsEnabled={isNarrowWindowsEnabled}
            />
          </Row>
        </Row>
      }
      title={'Outbound Planning Throughput (units/hr)'}
      values={shiftPlannedThroughput.flatMap((item) => {
        const { start_time_local, end_time_local } = item;
        const keyMap = THROUGHPUT_KEY_MAP[businessType] || THROUGHPUT_KEY_MAP[BUSINESS_VIEW_NAME.CORE];
        const timeRange = `${displayTime(start_time_local)}-${displayTime(end_time_local)}`;

        if (isRushIndirectRulesEnabled) {
          const speeds = [
            {
              speed: '5H',
              speedLabel: '5 Hour Speed',
              units: item[keyMap.total_units_5H],
              unitsPerHour: item[keyMap.total_units_per_hour_5H]
            },
            {
              speed: '3H',
              speedLabel: '3 Hour Speed',
              units: item[keyMap.total_units_3H],
              unitsPerHour: item[keyMap.total_units_per_hour_3H]
            },
            {
              speed: '1H',
              speedLabel: '1 Hour Speed',
              units: item[keyMap.total_units_1H],
              unitsPerHour: item[keyMap.total_units_per_hour_1H]
            }
          ];

          return speeds.map(({ speed, speedLabel, units, unitsPerHour }) => ({
            title: `${speedLabel} | ${timeRange}`,
            subtext: `${Math.round(unitsPerHour || 0)}`,
            tooltipValues: [
              `Time: ${timeRange}`,
              `Speed: ${speedLabel}`,
              `Rate: ${Math.round(unitsPerHour || 0)} units/hr`,
              `Total Planned Throughput: ${Math.round(units || 0)}`
            ]
          }));
        } else {
          const total_units = item[keyMap.total_units_5H];
          const total_units_per_hour = item[keyMap.total_units_per_hour_5H];

          return [
            {
              title: timeRange,
              subtext: Math.round(Number(total_units_per_hour) || 0),
              tooltipValues: [`Total Planned Throughput: ${Math.round(total_units || 0)}`]
            }
          ];
        }
      })}
    />
  );
};

export default ShiftPlannedThroughput;
